import React, {useState} from 'react';
import {Icon, Typography} from '@voltmoney/component';
import {
  ColorTokens,
  FontFamilyTokens,
  FontSizeTokens,
  IconSizeTokens,
  IconTokens,
} from '@voltmoney/schema';
import {Pressable, StyleSheet, useWindowDimensions, View} from 'react-native';
import {BreakPoints} from '../../configs/util';
import {fontFamilyTokensMap} from '@voltmoney/theme/lib/light-mobile/typography';
import {colorTokensMap} from '@voltmoney/theme/lib/colors';

export type FaqCollapsibleProps = {
  question: string;
  answer: any;
};

const FaqCollapsible: React.FunctionComponent<FaqCollapsibleProps> = ({
  question,
  answer,
}) => {
  const [open, setOPen] = useState(false);
  const {width} = useWindowDimensions();

  const toggle = () => {
    setOPen(!open);
  };

  const styles = StyleSheet.create({
    FaqCollapsibleContainer: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#FFFFFF',
      borderColor: '#F3F5FC',
      borderWidth: 1,
      borderRadius: 8,
      width: 733,
      paddingHorizontal: 23,
      paddingVertical: 23,
      boxShadow: '0px 4px 8px #F7F8FA',
    },
    FaqCollapsibleContainerMob: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#FFFFFF',
      borderWidth: 1,
      borderColor: '#F3F5FC',
      borderRadius: 8,
      width: 328,
      paddingHorizontal: 16,
      paddingVertical: 16,
      boxShadow: '0px 4px 8px #F7F8FA',
    },
    Faqs_ContainerQuestionItem: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    Faqs_ContainerQuestionItemQuestion: {
      width: '95%',
      fontFamily: fontFamilyTokensMap[FontFamilyTokens.Inter],
      fontStyle: 'normal',
      fontWeight: '600',
      fontSize: 12,
      lineHeight: 18,
      color: '#1D2939',
    },
    Faqs_ContainerQuestionArrowVector: {
      flex: 1,
      height: '100%',
      alignItems: 'center',
      position: 'relative',
      top: 10,
    },
    Faqs_ContainerToggleContainer: {
      width: '95%',
      height: 'fit-content',
    },
    Faqs_ContainerToggleContainerContent: {
      fontFamily: fontFamilyTokensMap[FontFamilyTokens.Inter],
      fontSize: 12,
      lineHeight: 24,
      width: '100%',
      height: '100%',
      textAlign: 'justify',
      paddingLeft: 2,
      paddingTop: 16,
      borderRadius: 10,
      color: colorTokensMap[ColorTokens.Grey_Charcoal],
    },
    Faqs_ContainerToggleContainerContentWeb: {
      fontFamily: fontFamilyTokensMap[FontFamilyTokens.Inter],
      fontSize: 16,
      lineHeight: 24,
      width: '100%',
      height: '100%',
      textAlign: 'justify',
      paddingLeft: 2,
      paddingTop: 16,
      borderRadius: 10,
      color: colorTokensMap[ColorTokens.Grey_Charcoal],
    },
  });

  return (
    <Pressable
      style={
        width > BreakPoints.WEB
          ? styles.FaqCollapsibleContainer
          : styles.FaqCollapsibleContainerMob
      }
      onPress={toggle}>
      <View style={styles.Faqs_ContainerQuestionItem}>
        <View style={styles.Faqs_ContainerQuestionItemQuestion}>
          <Typography.Component
            label={question}
            fontSize={
              width > BreakPoints.WEB ? FontSizeTokens.LG : FontSizeTokens.XS
            }
            fontFamily={FontFamilyTokens.Poppins}
            fontWeight={'600'}
            lineHeight={26}
            color={ColorTokens.Grey_Night}
          />
        </View>
        <View style={styles.Faqs_ContainerQuestionArrowVector}>
          {!open ? (
            <Icon.Component name={IconTokens.ChevronDown} />
          ) : (
            <View
              style={{
                position: 'relative',
                bottom: 10,
              }}>
              <Icon.Component
                name={IconTokens.ChevronUp}
                size={IconSizeTokens.XXXL}
                color={ColorTokens.Grey_Charcoal}
              />
            </View>
          )}
        </View>
      </View>
      {open && (
        <View style={styles.Faqs_ContainerToggleContainer}>
          <View
            style={
              width < BreakPoints.WEB
                ? styles.Faqs_ContainerToggleContainerContent
                : styles.Faqs_ContainerToggleContainerContentWeb
            }>
            {answer()}
          </View>
        </View>
      )}
    </Pressable>
  );
};
export default FaqCollapsible;
